import { Avatar, Button, Card, Row, Skeleton } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { contextApp } from "../../firebase/context";
import { getColection } from "../../firebase/fireStore";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import Cargando from "../../components/Cargando";
import agenda from "../../assets/images/icons/agenda.png";
import { useHistory } from "react-router-dom";

const { Meta } = Card;
const Inicio = () => {
  let history = useHistory();
  const { usuario } = useContext(contextApp);
  console.log("...." + usuario);
  const [loading, setLoading] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const [reminders, setreminders] = useState([]);
  const getProfesionales = async () => {
    setIsLogin(true);
    setLoading(true);
    const response = (await getColection("Appointment")) || [];
    const getdata = response.filter(
      (item) =>
        item.data.emailPaciente === usuario.email &&
        item.data.status === "Agendada"
    );
    setreminders(getdata);
    setIsLogin(false);
    setLoading(false);
    //setTopic(getdata.data.topic);
  };
  useEffect(() => {
    getProfesionales();
  }, [usuario]);

  const eliminaDuplicados = (arr) => {
    return [...new Set(arr)];
  };
  const data = reminders.map((item) => [
    item.data.namePsicologo,
    item.data.chat,
    item.data.photoPsicologo,
    item.data.paid,
    item.data.emailPsicologo,
  ]);

  return (
    <div>
      <h1>Mi profesional en psicología</h1>
      <div></div>
      {data.length > 0 ? (
        <Card
          style={{
            width: 200,
            height: 150,
            marginTop: 16,
            marginLeft: 16,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Avatar
              src={
                data[0][2]
                  ? data[0][2]
                  : "https://firebasestorage.googleapis.com/v0/b/kameliadev-a0de5.appspot.com/o/photoURL%2FDefault%2Fprofile_icon.png?alt=media&token=df0e7294-8dee-40cd-ab9e-4fd18c723df7"
              }
            />
            <div style={{ padding: 10 }}>{data[0][0]}</div>

            {data[0][3] ? (
              <div>
                <Button
                  style={{
                    backgroundColor: "white",
                    color: "var(--emphasis)",
                    width: "50%",
                    marginTop: 10,
                  }}
                  type="link"
                  onClick={() => window.open(data[0][1], "_blank")}
                >
                  Chat
                </Button>
              </div>
            ) : (
              <Button
                style={{ marginTop: 10 }}
                onClick={() =>
                  window.open("https://kameliapp.com/precios/", "_blank")
                }
              >
                Sucribirse
              </Button>
            )}
          </div>
        </Card>
      ) : (
        <div>
          <Card
            style={{
              width: 300,
              height: 150,
              marginTop: 16,
              marginLeft: 16,
            }}
          >
            <div>Aún no tienes un profesional asignado</div>
            <div style={{ display: "flex", marginTop: "10%" }}>
              <Button
                onClick={() =>
                  window.open("https://forms.gle/vW11hdAcf7Z9D8WBA", "_blank")
                }
              >
                Realizar Test
              </Button>
              <div style={{ margin: 10 }}>ó</div>
              <Button
                onClick={() => {
                  history.push("/profesionales/");
                }}
              >
                Ver profesionales
              </Button>
            </div>
          </Card>
        </div>
      )}
      {loading && <Cargando />}
      <h1 style={{ marginTop: 20 }}>Mis citas agendadas</h1>
      <Row gutter={16}>
        {(reminders || []).length > 0 ? (
          (reminders || []).map((reminder, index) => (
            <Card
              key={index}
              style={{
                width: 250,
                marginTop: 16,
                marginLeft: 16,
              }}
            >
              {" "}
              {isLogin === true ? (
                <Skeleton avatar active />
              ) : (
                <>
                  <Meta
                    avatar={
                      <Avatar
                        style={{ width: 50, height: 50 }}
                        src={
                          reminder.data.photoPsicologo
                            ? reminder.data.photoPsicologo
                            : "https://firebasestorage.googleapis.com/v0/b/kameliadev-a0de5.appspot.com/o/photoURL%2FDefault%2Fprofile_icon.png?alt=media&token=df0e7294-8dee-40cd-ab9e-4fd18c723df7"
                        }
                      />
                    }
                    title={`Cita con `}
                    description={reminder.data.namePsicologo}
                  />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Estado: <div> {reminder.data.status}</div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Fecha:{" "}
                    <div>
                      {" "}
                      {format(new Date(reminder.data.date), "PPP", {
                        locale: es,
                      })}
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Hora: <div> {reminder.data.time}</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    Suscripción:{" "}
                    <div>
                      {reminder.data.paid ? (
                        <div style={{ color: "#688C07" }}>Activa</div>
                      ) : (
                        <div style={{ color: "#FF141F" }}>Inactiva</div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    {reminder.data.status === "Agendada" &&
                    reminder.data.paid ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          onClick={() =>
                            window.open(reminder.data.beeoroLink, "_blank")
                          }
                        >
                          Entrar a la cita
                        </Button>
                        {/*<Button
                          style={{
                            backgroundColor: "white",
                            textAlign: "center",
                          }}
                        >
                          Reagendar
                        </Button>*/}
                      </div>
                    ) : reminder.data.status !== "Agendada" ? (
                      <div>
                        {/*<Button
                          onClick={() =>
                            window.open(
                              "https://kameliapp.com/precios/",
                              "_blank"
                            )
                          }
                        >
                          Reagendar
                        </Button>*/}
                      </div>
                    ) : (
                      <Button
                        onClick={() =>
                          window.open(
                            "https://kameliapp.com/precios/",
                            "_blank"
                          )
                        }
                      >
                        Sucribirse
                      </Button>
                    )}
                    {reminder.data.paid ? (
                      <Button
                        style={{
                          backgroundColor: "white",
                          color: "var(--emphasis)",
                          width: "50%",
                        }}
                        type="link"
                        onClick={() =>
                          window.open(reminder.data.chat, "_blank")
                        }
                      >
                        Chat
                      </Button>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </>
              )}
            </Card>
          ))
        ) : (
          <div style={{ display: "flex" }}>
            <img src={agenda} width={100} alt="agenda" />
            <h2>"No tienes citas Aún."</h2>
          </div>
        )}
      </Row>
    </div>
  );
};

export default Inicio;
